const StudentDetailsBox = ({ studentDetails }) => {
  if (studentDetails === null) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6 mb-6 border-l-4 border-primary-600"></div>
    );
  }
  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-6 border-l-4 border-yellow-600">
      <h3 className="text-lg font-bold text-gray-900 mb-4">Student Details</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div>
          <span className="text-xs text-gray-500">Name</span>
          <p className="font-semibold text-sm text-gray-900">
            {studentDetails.FirstName || ""} {studentDetails.LastName || ""}
          </p>
        </div>
        <div>
          <span className="text-xs text-gray-500">Student ID</span>
          <p className="font-semibold text-sm text-gray-900">
            {studentDetails.StudentId || ""}
          </p>
        </div>
        <div>
          <span className="text-xs text-gray-500">Mobile Number</span>
          <p className="font-semibold text-sm text-gray-900">
            {studentDetails.MobileNo || ""}
          </p>
        </div>
        <div>
          <span className="text-xs text-gray-500">Email</span>
          <p className="font-semibold text-sm text-gray-900">
            {studentDetails.Email || ""}
          </p>
        </div>
      </div>
    </div>
  );
};

export default StudentDetailsBox;
